import instance from "../../helpers/AxiosInterceptor";

export const loadVhuLots = () => {
  return instance.get("/vhu/admin/lots");
};

export const loadExpiredVhuLots = () => {
  return instance.get("/vhu/admin/lots/expired");
};

export const loadVhuLot = (id) => {
  return instance.get(`/vhu/admin/lots/${id}`);
};

export const saveVhuLot = (request) => {
  return instance.post("/vhu/admin/lots", JSON.stringify(request));
};

export const deleteVhuLot = (id) => {
  return instance.delete(`/vhu/admin/lots/${id}`);
};

export const loadVhuBids = () => {
  return instance.get("/vhu/admin/bids");
};

export const loadVhuLotBids = (id) => {
  return instance.get(`/vhu/admin/lots/${id}/bids`);
};

export const confirmVhuDecision = (lotId, request) => {
  return instance.post(`/vhu/admin/lots/${lotId}/decision`, JSON.stringify(request));
};
